module.exports = require("react-dropzone");


//////////////////
// WEBPACK FOOTER
// external "react-dropzone"
// module id = 222
// module chunks = 0